/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CTRoleEnum {
  CT_ADMIN = "CT_ADMIN",
  CT_APPRENTICE_TRAINER = "CT_APPRENTICE_TRAINER",
  CT_LEAD_TRAINER = "CT_LEAD_TRAINER",
  CT_SUPER_ADMIN = "CT_SUPER_ADMIN",
  CT_TRAINER = "CT_TRAINER",
  CT_USER = "CT_USER",
}

export enum CreditTypeEnum {
  PROGRAM = "PROGRAM",
  REFERRAL = "REFERRAL",
}

export enum OrderStatus {
  finalized = "finalized",
  pending = "pending",
  refunded = "refunded",
}

export enum RoleEnum {
  ADMIN = "ADMIN",
  CITY_LEAD = "CITY_LEAD",
  FACILITATOR = "FACILITATOR",
  HOST = "HOST",
  PARTICIPANT = "PARTICIPANT",
  TRAINER = "TRAINER",
}

export interface AdminMembershipReportFilterInput {
  status?: number | null;
  type?: string | null;
}

export interface AdminReportForRoleFilterInput {
  role: number;
}

/**
 * Information for applying/redeeming user credits at checkout
 */
export interface ApplyCreditsInput {
  amount: number;
  creditType: CreditTypeEnum;
}

export interface BeOurGuestsFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

/**
 * Info required to create or update a shipping address
 */
export interface BillingAddressInput {
  asUserId?: string | null;
  id?: string | null;
  address1: string;
  address2?: string | null;
  city: string;
  state?: string | null;
  zip?: string | null;
  country: string;
}

/**
 * Ids for cancelling a membership
 */
export interface CancelInputIds {
  ids?: string[] | null;
}

/**
 * Updating a course access input
 */
export interface ChangeCourseAccessInput {
  id?: string | null;
  courseId: string;
  enabled: boolean;
}

/**
 * Information for creating a new Community
 */
export interface CommunityInput {
  id?: string | null;
  name?: string | null;
  zip?: string | null;
  bannerImage?: any | null;
}

export interface ComplementaryOneOnOnesFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

/**
 * Information for sending an email to request a one on one training
 */
export interface ContactUsRequestInput {
  firstName: string;
  lastName: string;
  email: string;
  state: string;
  newsletterSignUp: boolean;
  subject: string;
  emailContent: string;
}

export interface CouponInput {
  code: string;
  amountOff: number;
  products?: string[] | null;
  startDateTime: string;
  endDateTime: string;
  isActive: boolean;
  isApplicableToEach: boolean;
}

export interface CouponUpdateInput {
  code?: string | null;
  amountOff?: number | null;
  products?: string[] | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  isActive?: boolean | null;
  isApplicableToEach?: boolean | null;
  id: string;
}

/**
 * Input for creating a payment intent for a charge
 */
export interface CreateChargePaymentIntentInput {
  id?: string | null;
  amount: number;
}

/**
 * Information for adding credits to a user
 */
export interface CreditInput {
  amount: number;
  description?: string | null;
  creditType: CreditTypeEnum;
  userId: string;
}

/**
 * Information for creating or updating an event
 */
export interface EventInput {
  id?: string | null;
  venueName?: string | null;
  venuePhone?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  zip?: string | null;
  maxAttendees?: number | null;
  communityIds?: string[] | null;
  productIds: string[];
  hidden: boolean;
  sku?: string | null;
  virtual: boolean;
  timezone?: string | null;
  sessions: EventSessionInput[];
  advancedTrainingType?: string | null;
  energyType?: string | null;
  format?: string | null;
  description?: string | null;
  title?: string | null;
}

/**
 * Information for creating or updating an Event Product Listing
 */
export interface EventProductListingInput {
  id?: string | null;
  description: string;
  productName: string;
  price: string;
  sku: string;
  img: string;
  accountingId: string;
  trainerLed?: boolean | null;
  powerOfType?: string | null;
  status?: string | null;
  relatedProducts?: string[] | null;
  courses?: string[] | null;
  daysToCancel: number;
  includesMedia?: boolean | null;
  lmsId?: string | null;
  apprenticeLed?: boolean | null;
  hidden?: boolean | null;
  membershipPrice?: number | null;
  firstTimeDiscountPrice?: number | null;
  reengagementPrice?: number | null;
  daysToRemainOnStore?: number | null;
}

/**
 * Information for creating or updating session
 */
export interface EventSessionInput {
  id?: string | null;
  startDateTime: string;
  endDateTime?: string | null;
  status?: string | null;
}

export interface EventsFilterInput {
  hidden?: boolean | null;
  inFuture?: boolean | null;
  eventProductId?: string | null;
  powerOfType?: string | null;
  isPowerOfEvent?: boolean | null;
  isTrainerLed?: boolean | null;
  trainers?: string[] | null;
  communities?: string[] | null;
  advancedTrainingTypes?: string[] | null;
  formats?: string[] | null;
  energyTypes?: string[] | null;
  powerOfTypes?: string[] | null;
  lessThan3WeeksAgo?: boolean | null;
  types?: string[] | null;
  archived?: boolean | null;
}

export interface ForgotPasswordInput {
  email: string;
  fromCt?: boolean | null;
}

export interface GuestPassesFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

export interface IntroOneOnOnesFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

export interface IntrosFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

export interface ItemBasedCouponInput {
  amountOff: number;
  products?: string[] | null;
  startDateTime: string;
  endDateTime: string;
  isActive: boolean;
  isApplicableToEach: boolean;
}

export interface ItemBasedCouponUpdateInput {
  amountOff?: number | null;
  products?: string[] | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  isActive?: boolean | null;
  isApplicableToEach?: boolean | null;
  id: string;
}

export interface MoveAttendeeInput {
  fromEventId: string;
  toEventId: string;
  attendeeId: string;
}

export interface NewPsWeekendAttendeesFilterInput {
  startDate?: string | null;
  endDate?: string | null;
}

/**
 * Information for saving an order
 */
export interface OrderInput {
  asUserId?: string | null;
  shippingAddress1?: string | null;
  shippingAddress2?: string | null;
  shippingCity?: string | null;
  shippingState?: string | null;
  shippingZip?: string | null;
  shippingCountry?: string | null;
  billingAddress1: string;
  billingAddress2?: string | null;
  billingCity: string;
  billingState: string;
  billingZip: string;
  billingCountry: string;
  billingPhoneNumber?: string | null;
  shippingTotal?: number | null;
  totalItemsPrice: number;
  status?: OrderStatus | null;
  referralEmail?: string | null;
}

export interface OrdersFilterInput {
  selectedStartDate?: string | null;
  maxPageSize?: number | null;
  lastId?: string | null;
  searchParam?: string | null;
  previous?: boolean | null;
  ignoreMaxPageSize?: boolean | null;
}

export interface PaginationParamsInput {
  page?: number | null;
  perPage?: number | null;
}

/**
 * Updating a course access input
 */
export interface PaymentMethodInput {
  id?: string | null;
  brand: string;
  expirationMonth: number;
  expirationYear: number;
  lastFour: number;
  default?: boolean | null;
}

/**
 * Information for creating or updating a Physical Product
 */
export interface PhysicalProductInput {
  id?: string | null;
  description: string;
  productName: string;
  physicalType?: string | null;
  price: string;
  sku: string;
  img: string;
  accountingId: string;
  relatedProducts?: string[] | null;
  status?: string | null;
  hidden?: boolean | null;
  membershipPrice?: number | null;
}

export interface ProductsFilterInput {
  status?: string | null;
  isApprenticeLed?: boolean | null;
  physicalTypes?: string[] | null;
  hidden?: boolean | null;
  corporatePackages?: boolean | null;
}

/**
 * Information for a participant to RSVP to an event
 */
export interface RsvpInput {
  asUserId?: string | null;
  eventId: string;
  productId: string;
  userId: string;
}

/**
 * Info required to create or update a shipping address
 */
export interface ShippingAddressInput {
  asUserId?: string | null;
  id?: string | null;
  address1: string;
  address2?: string | null;
  city: string;
  state?: string | null;
  zip?: string | null;
  country: string;
}

/**
 * Information for a single shopping cart attendee
 */
export interface ShoppingCartItemAttendeeInput {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

/**
 * Information for updating a user's shopping cart
 */
export interface ShoppingCartItemInput {
  asUserId?: string | null;
  id?: string | null;
  productId?: string | null;
  quantity: number;
  deliveryEmail?: string | null;
  attendees?: ShoppingCartItemAttendeeInput[] | null;
  eventId?: string | null;
  referral?: string | null;
  _destroy?: boolean | null;
  discount?: number | null;
}

/**
 * Testimonial Video Input Type
 */
export interface TestimonialInput {
  title?: string | null;
  url: string;
  description: string;
  isActive: boolean;
  isFeatured: boolean;
  tags?: string[] | null;
}

/**
 * Testimonial Video Input Type
 */
export interface TestimonialInputUpdate {
  id: string;
  title?: string | null;
  url: string;
  description: string;
  isActive: boolean;
  isFeatured: boolean;
  tags?: string[] | null;
}

export interface TestimonialsFilterInput {
  featuredLastTestimonial?: boolean | null;
  tags?: string[] | null;
}

/**
 * Information for creating or updating a text element
 */
export interface TextElementInput {
  pageId: string;
  elementId: string;
  entityId?: number | null;
  content: string;
}

export interface TrainerCrmFeeInput {
  fee: number;
  trainerId: string;
}

/**
 * Basic User Info
 */
export interface UserInput {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  newsletterSignedUp: boolean;
  password: string;
  passwordConfirmation: string;
  signedUpWithCtFirst?: boolean | null;
  communityIds: string[];
}

/**
 * Password Reset Information
 */
export interface UserInputPasswordReset {
  token: string;
  password: string;
  passwordConfirmation: string;
}

/**
 * Basic User Info
 */
export interface UserInputUpdate {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  bio: string;
  ctRole?: CTRoleEnum | null;
  imgRole?: RoleEnum | null;
  email: string;
  avatar?: any | null;
  password?: string | null;
  passwordConfirmation?: string | null;
  newsletterSignedUp: boolean;
  trainerServices?: string | null;
  subTrainers?: string[] | null;
  communities?: string[] | null;
  trainerMeetingLink?: string | null;
}

/**
 * Adds a new or updates a previously added shipping address for a user
 */
export interface UserInputUpdateShippingAddress {
  id: string;
  shippingAddress: ShippingAddressInput;
}

export interface UsersFilterInput {
  roles?: RoleEnum[] | null;
  search?: string | null;
}

/**
 * Information for creating or updating a Virtual Product
 */
export interface VirtualProductInput {
  id?: string | null;
  description: string;
  physicalType?: string | null;
  productName: string;
  price: string;
  sku: string;
  img: string;
  accountingId: string;
  relatedProducts?: string[] | null;
  lmsId?: string | null;
  courses?: string[] | null;
  status?: string | null;
  hidden?: boolean | null;
  membershipPrice?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
